<script>
    import Card from '@/components/Card'

    export default {
        components: {
            Card,
        },

        mounted() {
            this.$root.restrictCountries('*')
            this.$store.commit('mainPage', {
                current: this.$t('Systems'),
                stack: [{
                    'path': '/systems',
                    'title': this.$t('Systems'),
                }]
            })
        },
    }
</script>

<template>
    <section class="section">
        <div class="container-fluid">
            <card class="is-card-table has-pagination has-bottom-left-hidden">
                <bg-table-systems :label="$t('Systems')" group-by="ProductId" group-data="Product"/>
            </card>
        </div>
    </section>
</template>
